import React from "react";
import PropTypes from "prop-types";
import { Box, Skeleton, Stack } from "@mui/material";

import "./index.scss";

/**
 * Placeholder shapes for content that is still loading.
 *
 * A skeleton that matches the shape of the incoming content reads as faster
 * than a centred spinner, which gives the reader nothing to anchor on.
 */
export function SkCardSkeleton() {
  return (
    <Box className="sk-skeleton__card">
      <Skeleton variant="rectangular" className="sk-skeleton__thumb" />
      <Skeleton variant="text" width="80%" height={16} />
      <Skeleton variant="text" width="55%" height={14} />
    </Box>
  );
}

export function SkRowSkeleton() {
  return (
    <Stack direction="row" spacing={2} alignItems="center" className="sk-skeleton__row">
      <Skeleton variant="rectangular" width={48} height={48} className="sk-skeleton__avatar" />
      <Box flex={1}>
        <Skeleton variant="text" width="40%" height={16} />
        <Skeleton variant="text" width="25%" height={14} />
      </Box>
    </Stack>
  );
}

export default function SkSkeleton({ variant, count }) {
  const Item = variant === "row" ? SkRowSkeleton : SkCardSkeleton;

  return (
    <Box
      className={`sk-skeleton sk-skeleton--${variant}`}
      role="status"
      aria-live="polite"
      aria-label="Loading"
    >
      {Array.from({ length: count }, (unused, index) => (
        <Item key={index} />
      ))}
    </Box>
  );
}

SkSkeleton.propTypes = {
  variant: PropTypes.oneOf(["card", "row"]),
  count: PropTypes.number,
};

SkSkeleton.defaultProps = {
  variant: "card",
  count: 8,
};
